// src/lib/notify/sendEmailVerification.js
import { callFunctionRaw } from "@/lib/callFunction";

const LS_KEY_PREFIX = "afrimed:email_code:last_sent:";
const MIN_INTERVAL_MS = 60 * 1000; // 60s safety
let inflight = null;

export async function sendEmailVerification(email) {
  const e = String(email || "").trim().toLowerCase();
  if (!e || !/^\S+@\S+\.\S+$/.test(e)) {
    return { ok: false, error: "invalid_email" };
  }

  // ✅ Prevent double-fire in same render cycle / double click
  if (inflight) return inflight;

  inflight = (async () => {
    try {
      // ✅ Client throttle (stops “twice a minute” spam even if UI calls twice)
      try {
        const key = `${LS_KEY_PREFIX}${e}`;
        const last = Number(localStorage.getItem(key) || "0");
        if (last && Date.now() - last < MIN_INTERVAL_MS) {
          return { ok: true, throttled: true };
        }
        localStorage.setItem(key, String(Date.now()));
      } catch {
        // ignore storage issues
      }

      // Server call (Edge function also rate-limits; see paste-over #2)
      const res = await callFunctionRaw("send-email-code", { email: e });

      if (!res?.ok) {
        return { ok: false, error: res?.error || "send_failed" };
      }

      return { ok: true };
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}